//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Formboard.js";
import "../no/TransientObject.js";
let d=[[[0,"Description",0,0],[0,"DiscrepancyObjectType",0,0],[0,"DiscrepancyType",0,0],[0,"FormboardObject",0,"NXObject",0],[0,"HarnessObject",0,"NXObject",0]],[[[],"Dispose",{},0,0]],[]];
SPLM.Formboard.UpdateDiscrepancy = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Formboard.UpdateDiscrepancy";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Formboard.UpdateDiscrepancy.Type = Object.freeze({
    "Unknown" : "Unknown", "Missing" : "Missing", "Extra" : "Extra", "Modified" : "Modified"});

SPLM.Formboard.UpdateDiscrepancy.ObjectType = Object.freeze({
    "Unknown" : "Unknown", "Rcp" : "Rcp", "Segment" : "Segment", "Clip" : "Clip", "Component" : "Component", "Harness" : "Harness", "Wire" : "Wire", "Cable" : "Cable", "Shield" : "Shield", "Connector" : "Connector", "Device" : "Device", "Overstock" : "Overstock", "Fillerstock" : "Fillerstock", "FittingOverstock" : "FittingOverstock"});

export default SPLM;